export default {
	borderRadius: 4,
	buttonHorizontalPadding: '1.5em',
	inputHeight: 42,
	inputHorizontalPadding: '1em'
};
